

















import store from "@/general/store";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  store: store,
  filters: {
    customDateFormat(value: string) {
      return value.split("T")[0];
    }
  }
})
export default class TheL04Header extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) publishedAt!: string;
  @Prop({ type: String, required: true }) updatedAt!: string;
  @Prop({ type: String, required: true }) authorName!: string;
  @Prop({ type: Number, required: true }) authorId!: number;
}
